import './App.css';
import Pokemon from './data/pokemon.json';
import Arrow from './Arrow';
import React from 'react';
import Autocomplete from "./Autocomplete";
import {Fragment} from "react";
import Timer from "./Timer";
import Dialog2 from "./Dialog2";
import {encryptStorage} from "./utils/storage";
import {getLocalizedString} from "./utils/TranslationData"
import ShareSocialMedia from "./ShareSocialMedia";
import {Navigate, useNavigate, useParams} from "react-router-dom";

function withParams(Component) {
    return props => <Component {...props} stats={useParams().stats} navigate={useNavigate()} />;

}

// eslint-disable-next-line no-undef
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 1,
            textPokemon : "",
            evaluateAnswer : "",
            listPokemon : [],
            disableInput : false,
            displayBackArrow: true,
            displayElem: {pokemon: true},
            remaining: 0,
            timer: null,
            dialogDel: React.createRef(),
            dialogInit: React.createRef(),
            buttonStop : React.createRef(),
            mode: 0,
            email:"",
            sortedIdPokemon:0,
            answer: null,
            last10Pokemon: [],
            isReset: false,
            chosenGen : "",
            autocompleteOpt : true
        };
    }


    confirmResetProgression = () => {
        encryptStorage.removeItem('pokemonNorm')
        this.initialPokedex();
        if(this.state.mode===1) {
            this.setState( { isReset : true})
            this.state.buttonStop.current.resetTimer()
        }
        this.setState({disableInput : false}, () => {this.updateDisplayFormStatus( true);
            this.changeMode(0)});
    }

    refreshKnownPokemon(initialList, listFilter) {
        const langKey = this.props?.lang;
        const filterList = listFilter?.[langKey] ?? [];

        if (!Array.isArray(initialList)) {
            return [];
        }

        const filterSet = new Set(filterList);

        const result = initialList.filter(pokemon =>
            !filterSet.has(pokemon.id)
        );

        this.setState({ remaining: result.length });
        return result;
    }

    handlePokemonChoice(sortedIdPokemon, updateState = false) {

        if (sortedIdPokemon === 0) {
            this.randomPokemon();
        }

        else if (sortedIdPokemon === 1) {
            this.byOrderPokemon(updateState)

        }

        else {
            const chosenGen = this.state.chosenGen || 1;

            this.setState({ chosenGen }, () => {
                this.pokemonByGen(chosenGen, updateState);
            });
        }

        if (updateState) {
            this.setState({ sortedIdPokemon }, () => {this.handleStop(false)});
        }
    }


    randomPokemon()  {
        const notKnownPokemon = this.refreshKnownPokemon(Pokemon, this.state.listPokemon)
        const min = 0;
        const max = notKnownPokemon.length;
        const rand = Math.floor(min + Math.random() * (max - min));
        const actualPokemonId = Pokemon.find(x => x.id === notKnownPokemon[rand].id)
        if (max === 0) {
            this.setState({count : -1, textPokemon : ""})
            return;
        }
        this.setState({ count: actualPokemonId['id'], textPokemon : ""});

    }

    byOrderPokemon(updateState = false, listPokemon = Pokemon) {
        let {count} = this.state;
        const notKnownPokemonList = this.refreshKnownPokemon(listPokemon, this.state.listPokemon);
        const max = notKnownPokemonList.length;

        if (max === 0) {
            this.setState({count : -1, textPokemon : ""})
            return;
        }

        if (updateState) {
            this.setState({ count: notKnownPokemonList[0]?.id });
        }
        else {
            const nextIndex = notKnownPokemonList.findIndex(x => x.id > count) ;
            const nextPokemon =  (nextIndex === -1) ? notKnownPokemonList[0] : notKnownPokemonList[nextIndex];
            this.setState({ count: nextPokemon?.id, textPokemon: ""});
        }

    }

    pokemonByGen(nbGen, updateState) {
        const allPokemonGen = Pokemon.filter(x => (x['gen'] === nbGen))
        const notKnownPokemon = this.refreshKnownPokemon(allPokemonGen, this.state.listPokemon)
        const max = notKnownPokemon.length;
        if (max === 0) {
            this.setState({count : -1, textPokemon : ""})
            return;
        }

        if(updateState) {
            const firstPokemonGen = notKnownPokemon[0]?.id;
            this.setState({count: firstPokemonGen});
        }
        else {
            this.byOrderPokemon(updateState, allPokemonGen);
        }
    }

    initialPokedex = () => {
        this.setState({ listPokemon: this.state.mode === 0 ? (
                encryptStorage.getItem('pokemonNorm', false)
                ||
                []
            ) : []}, () =>
        {this.randomPokemon();
        });
    }

    componentDidMount() {
        this.initialPokedex();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.displayElem.pokemon !== this.state.displayElem.pokemon) {
            this.randomPokemon();
        }
        if(prevState.mode !== this.state.mode) {
            this.initialPokedex();
            this.props.changeMode(this.state.mode);
        }
        if(prevProps.lang !== this.props.lang) {
            this.handlePokemonChoice(this.state.sortedIdPokemon)
        }
    }

    async validatePokemon(real_pokemon, input_pokemon) {
        const actualPokemon = Pokemon.find(x => x.id === this.state.count);
        const langKey = this.props.lang;
        const isCorrect = real_pokemon.toLowerCase() === input_pokemon.toLowerCase();

        if (isCorrect) {
            this.setState(prevState => {
                const updatedList = {
                    ...prevState.listPokemon,
                    [langKey]: [
                        ...(prevState.listPokemon[langKey] || []),
                        actualPokemon.id
                    ]
                };

                if (prevState.mode === 0) {
                    encryptStorage.setItem('pokemonNorm', JSON.stringify(updatedList));
                }

                return {
                    listPokemon: updatedList,
                    evaluateAnswer: 'correct',
                    answer: null
                };
            }, () => {
                this.handlePokemonChoice(this.state.sortedIdPokemon);
            });
        } else {
            this.setState(prevState => ({
                last10Pokemon: [...prevState.last10Pokemon, actualPokemon.id].slice(-10),
                evaluateAnswer: "incorrect",
                answer: real_pokemon.toUpperCase()
            }), () => {
                this.handlePokemonChoice(this.state.sortedIdPokemon);
            });
        }

        setTimeout(() => {
            this.setState({ evaluateAnswer: "" });
        }, 1000);

        await fetch('/server/countClicks/nm');
    }



    updateDisplayFormStatus = (togglePoke) => {
        this.setState({
            displayElem : {
                pokemon : togglePoke
            }
        })
    }

    handleNameChange = (textPokemon) => {
        this.setState({textPokemon})
    }

    handleStop = (disableInput) =>  {
        this.setState({disableInput})
    }

    filterPokemonById = (listPokemon, userPokemon, lang) => {
       return listPokemon
           .filter(pkLang => !userPokemon[lang]?.some(x => x === pkLang.id))
           .map((x) => x['names'][lang])
    }

    setTimer = (timer) => {
        this.setState({timer})
    }

    sendForm = async () => {
        try {
            const url = `/server/record`;
            const email = this.state.email.trim();
            const nickname = this.state.nickname;
            const listPokemon = this.state.listPokemon;

            const pokemonLength = (langName) => {
                return listPokemon?.[langName]?.length ?? 0;
            };


            const countPokemonByLang = { fr: 0, en: 0, de: 0 };

            Object.keys(countPokemonByLang).forEach(
                (x) => {countPokemonByLang[x] = pokemonLength(x);}
            )

            function argMax(array) {
                return array
                    .map((x, i) => [x, i])
                    .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
            }

            const values = Object.values(countPokemonByLang);
            const nbPok = Math.max(...values)
            const langKey = argMax(values);


            await this.claimToken({nbPok, langKey, email});


            const response = await fetch(url);
            const data = await response.json();


            const emailExists = await data.message.some(entry => entry.email === email);

            const formData = await ({
                nickname,
                email,
            });

            const method = await emailExists ? 'PATCH' : 'POST';

            const add_user_record_response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if(add_user_record_response.ok) {
                this.props.navigate('./leaderboard')
            }

        }
        catch (error) {
            console.error('Request failed', error);
        }
    }

    handleDialogSubmit = (e) => {
        e.preventDefault();
        this.state.dialogInit.current.closeDialog();
        this.handleStop(false);
        this.state.buttonStop.current.startTimer();
    };

    changeMode = (mode) => {
        this.setState({mode})
        this.props.changeMode({mode})
        if(mode === 1) {
            this.handlePokemonChoice(0, true);
        }
    }

    claimToken = async (hash) => {
         await fetch('/server/token', {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json',
             },
             body: JSON.stringify({hash}),
         })
    }


    render() {
        const { remaining, listPokemon, count} = this.state;
        const actualPokemonObj = Pokemon.find(x => x.id === count);
        const langKey = this.props.lang;
        const situationMode = this.state.mode === 0 ? 'Normal' : 'Record';
        const genMax = 9;

        const buttonSwitchMode = (mode) => {
            if(mode === 0) {
                return (
                    <Fragment>
                        <label style={{textAlign : "center", pointerEvents: "none"}}>
                            🎁 <b> {getLocalizedString(this.props.lang, 'infoRecord')} </b>
                            <br />
                        <button
                            type="button"
                            style={{pointerEvents: "auto"}}
                            onClick={async () => {
                                this.changeMode(1);
                                this.updateDisplayFormStatus(false)
                                this.state.dialogInit.current.openDialog();
                                this.handleStop(true);
                                await fetch('/server/countClicks/re')
                            }}
                        >
                            {getLocalizedString(this.props.lang, 'switchModeButton', { mode: 'Record' })}
                        </button>
                        </label>
                    </Fragment>
                )
            }
            else {
                return (<button
                    type="button"
                    onClick={() => {
                        this.updateDisplayFormStatus(true);
                        this.changeMode(0);
                    }}
                >
                    {getLocalizedString(this.props.lang, 'switchModeButton', {mode : 'Normal'})}
                </button>)
            }
        }

        return (
            <div className="appDomain">

                {!!this.props.stats && <Navigate to={'..'} replace={true}/>}
                <em style={{"position" : "absolute", "right" : "0"}}>  {getLocalizedString(this.props.lang, "remainingPokemon", { count: remaining })}</em>
                <div className={"containerForm"}>
                <form id="pokemon-query" className={`formPokemon ${this.state.evaluateAnswer}`} onSubmit={(e) => e.preventDefault()}>
                    <div className={"containerImg"}>
                        <div className={"borderImg"}>
                            {
                                this.state.count === -1 ? <em> You have found all possible Pokemon
                                        {!this.state.chosenGen ? <></> : <> for the generation n°{this.state.chosenGen} </>} </em> :
                                this.state.displayElem.pokemon ? <img
                                        src={require(`./images/${actualPokemonObj.id}.png`)}
                                        alt={"not found"}
                                    /> : <em> No Pokemon to display ! </em>

                            }
                        </div>
                    </div>

                    <div className="input-button-wrapper">
                        {(this.state.mode === 0 && this.state.answer) && <em> Answer : {this.state.answer} </em>}
                        <div className="autocomplete-container">
                            <Autocomplete suggestions={this.filterPokemonById(Pokemon, listPokemon,  langKey)}
                                          showSuggestion={this.state.autocompleteOpt}
                                          mode={this.state.mode}
                                          name={this.state.textPokemon}
                                          onNameChange={this.handleNameChange}
                                          disableInput={this.state.disableInput}/>
                        </div>
                        <Arrow
                            id="left"
                            text="Back"
                            display={this.state.back}
                            onClick={() => {
                                let previousCount; // we'll capture it outside setState so callback can use it

                                this.setState(prevState => {
                                    const last10Pokemon = [...prevState.last10Pokemon];
                                    previousCount = last10Pokemon.pop();

                                    return {
                                        last10Pokemon,
                                        back: previousCount ? prevState.back : 'none',
                                    };
                                }, () => {
                                    if (previousCount) {
                                        this.handleStop(true);

                                        const pokemon = Pokemon.find(p => p.id === previousCount);
                                        if (pokemon) {
                                            this.setState({
                                                count: previousCount,
                                                answer: pokemon.names[langKey] || '',
                                            });
                                        } else {
                                            console.warn(`No Pokémon found with id ${previousCount}`);
                                        }
                                    }
                                });
                            }}
                        />
                        <Arrow id="right" text="Pass" onClick={() => {
                                this.handlePokemonChoice(this.state.sortedIdPokemon)
                                this.setState(prevState => ({
                                    answer: actualPokemonObj['names'][langKey].toUpperCase(),
                                    last10Pokemon: [...prevState.last10Pokemon, actualPokemonObj['id']],
                                    back: 'true'
                                }))
                                this.handleStop(false)}}/>

                        <button title={"Guess the Pokemon !"} id={"queryPokemon"} onClick= { () => this.validatePokemon(actualPokemonObj['names'][langKey], this.state.textPokemon)} type={"submit"}/>
                    </div>

                </form>
                </div>

                {this.state.mode === 1 && (<Timer
                    ref={this.state.buttonStop}
                    handleTimer={this.handleStop}
                    setTimerApp={this.setTimer}
                    updateForm={this.updateDisplayFormStatus}
                    mode={this.state.mode}
                    isReset={this.state.isReset}
                    user={this.state.email}
                    sendForm={this.sendForm}
                    setReset={(isReset) => this.setState({isReset})}
                />)}

                <div className="selectionMode">

                    {this.state.mode === 0 && buttonSwitchMode(0)}


                    <ShareSocialMedia lang={langKey} nbPokemonUser={listPokemon.length} nbPokemon={Pokemon.length} contentKey={'appTitle'}/>


                    {this.state.mode === 0 && (
                        <div className="radioDisplayCurrentPokemon">
                            <b>{getLocalizedString(this.props.lang, 'labelDisplayPokemon')['autocomplete']}</b>
                            <input
                                type="checkbox"
                                id="autocompletion-option"
                                checked={this.state.autocompleteOpt}
                                onChange={() => this.setState({autocompleteOpt : !this.state.autocompleteOpt})}
                            />
                            <b>{getLocalizedString(this.props.lang, 'displayPokemon')}</b>
                            <span>
        <input
            type="radio"
            id="randomMode"
            checked={this.state.sortedIdPokemon === 0}
            onChange={() => this.handlePokemonChoice(0, true)}
        />
        <label htmlFor="randomMode">{getLocalizedString(this.props.lang, "labelDisplayPokemon")['random']}</label>
      </span>
      <span>
        <input
            type="radio"
            id="orderMode"
            checked={this.state.sortedIdPokemon === 1}
            onChange={() => this.handlePokemonChoice(1, true)}
        />
        <label htmlFor="orderMode">{getLocalizedString(this.props.lang, "labelDisplayPokemon")['order']}</label>
      </span>
      <span>
        <input
            type="radio"
            id="genMode"
            checked={this.state.sortedIdPokemon === 2}
            onChange={() => this.handlePokemonChoice(2, true)}
        />
         <select
             id="gen-number"
             title="Choose your generation"
             value={this.state.chosenGen}
             onChange={(e) => {
                 const chosenGen = parseInt(e.target.value, 10);
                 this.setState({ chosenGen }, () => {
                     this.handlePokemonChoice(2, true);
                 });
             }}
         >
                {Array.from({length: genMax}, (_,i) => (i+1).toString()).map(id => (<option key={id} value={id}>{id}</option>))}
         </select>
        <label htmlFor="genMode">{getLocalizedString(this.props.lang, "labelDisplayPokemon")['gen']}</label>
      </span>
      </div>
      )}

                    {this.state.mode === 1 && buttonSwitchMode(1)}

                    <em style={{marginTop: '10px'}}>{getLocalizedString(this.props.lang, 'or')}</em>

                    <button
                        type="button"
                        onClick={() => this.state.dialogDel.current.openDialog()}
                    >
                        {getLocalizedString(this.props.lang, 'deleteProgressionButton',{mode : situationMode})}
                    </button>
                </div>


                <Dialog2 ref={this.state.dialogInit}>
                    <form id="leaderboard-form" className="pokemon-dialog-form" onSubmit={this.handleDialogSubmit}>
                        <div className="dialog-header">
                            {getLocalizedString(langKey, 'dialogReward')}
                        </div>

                        <div className="dialog-fields">
                            <label htmlFor="nickname">🎮 Nickname</label>
                            <input
                                id="nickname"
                                name="nickname"
                                maxLength={10}
                                required
                                placeholder={getLocalizedString(langKey, 'nicknamePlaceholder')}
                                onChange={(e) => this.setState({ nickname: e.target.value })}
                            />

                            <label htmlFor="email">📧 Email</label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="on"
                                required
                                placeholder={getLocalizedString(langKey, 'emailPlaceholder')}
                                onChange={(e) => this.setState({ email: e.target.value })}
                            />
                        </div>

                        <div className="dialog-buttons">

                            <button type="submit" className="poke-btn green">
                                ▶ {getLocalizedString(langKey, 'start')}
                            </button>

                            <button
                                type="button"
                                className="poke-btn yellow"
                                onClick={() => {
                                    this.state.dialogInit.current.closeDialog();
                                    this.changeMode(0);
                                    this.handleStop(false);
                                    this.updateDisplayFormStatus(true)
                                }}
                            >
                                ⬅ {getLocalizedString(langKey, 'back')}
                            </button>

                        </div>
                    </form>

                </Dialog2>
                <Dialog2 ref={this.state.dialogDel}>
                    <div className="dialog-header">
                        <p> {getLocalizedString(this.props.lang,"deleteProgression")} </p>
                    </div>
                    <div className="dialog-buttons">
                       <button type={"reset"} style={{padding: "5px", margin: "2px", background: 'greenyellow', cursor: 'pointer'}} onClick={() => {this.state.dialogDel.current.closeDialog(); this.confirmResetProgression()}}> Reset </button>
                       <button type={"button"} style={{padding: "5px", margin: "2px", background: 'greenyellow', cursor: 'pointer'}} onClick={() => {this.state.dialogDel.current.closeDialog(); if(this.state.mode === 1) {this.state.buttonStop.current.startTimer()}}}> Continue </button>
                       <button type={"button"} style={{padding: "5px", margin: "2px", background: 'greenyellow', cursor: 'pointer'}} onClick={() => {this.state.dialogDel.current.closeDialog(); this.changeMode(0); this.handleStop(false); }}> Back to Normal Mode </button>
                    </div>
                </Dialog2>


            </div>
        );
    }
}

export default withParams(App);
